<template>
   <div id="importModal" class="modal fade" role="dialog">
      <div class="modal-dialog">
         <!-- Modal content-->
         <div class="modal-content bg-sa-modal-content">
            <div class="modal-header bg-sa-modal-header">
               <h4 class="modal-title">{{ title }}</h4>
               <button type="button" class="btn-close color-sa-btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
               <!--AlertMessage (only when the page passes its alert) -->
               <AlertComponent
                  v-if="alert && alert.pageOrModal == 'modal'"
                  :alertstatus="alert.alertstatus"
                  :message="alert.alertMessage"
                  :type="alert.alertType"
               />
               <!--End AlertMessage -->

               <!-- Rows that were not imported, and why -->
               <div v-if="errors.length" class="alert alert-warning py-2 small">
                  <strong>
                     {{ errorsTitle }} ({{ errors.length }}{{ errors.length >= 200 ? '+' : '' }}):
                  </strong>
                  <ul class="mb-0 ps-3 mt-1 import-errors-list">
                     <li v-for="(problem, i) in errors" :key="i">{{ problem }}</li>
                  </ul>
               </div>

               <!--Progress Bar-->
               <FileUploadProgress
                  :uploading="formImportData.uploading"
                  :progress="formImportData.progress"
                  :message="formImportData.message"
                  :messageType="formImportData.messageType"
               />
               <!--End Progress Bar-->

               <!-- @submit.prevent: pressing Enter in a box must not reload the page -->
               <form id="importForm" @submit.prevent>
                  <template v-if="askSourceSystem">
                     <label class="form-label sa-core-color mb-1">Old system name</label>
                     <input
                        v-model="sourceSystemValue"
                        type="text"
                        class="form-control mb-2"
                        placeholder="e.g. quickbooks (same name for every file from that system)"
                     />
                  </template>
                  <label class="form-label sa-core-color mb-1">File (Excel or CSV)</label>
                  <input
                     ref="fileInput"
                     class="form-control mb-2"
                     type="file"
                     :accept="accept"
                     @change="$emit('file-change', $event)"
                  />
                  <div class="d-flex flex-wrap gap-2">
                     <button
                        @click="$emit('import')"
                        :disabled="!canImport"
                        class="btn btn-primary"
                        type="button"
                     >
                        <i class="fa fa-upload me-1"></i>Import
                     </button>

                     <!-- Fixed template file on the server -->
                     <a v-if="templateUrl" :href="templateUrl" class="btn btn-success" download>
                        <i class="fa fa-file-excel-o me-1"></i>Download Import Template
                     </a>
                     <!-- Template built by the page's API -->
                     <button
                        v-else
                        @click="$emit('download-template')"
                        :disabled="formImportData.templateLoading"
                        class="btn btn-success"
                        type="button"
                     >
                        <i class="me-1" :class="formImportData.templateLoading ? 'fa fa-cog fa-spin' : 'fa fa-file-excel-o'"></i>
                        {{ formImportData.templateLoading ? 'Preparing...' : 'Download Import Template' }}
                     </button>
                  </div>
               </form>

               <!-- The page's own Import Notes -->
               <slot />
            </div>
            <div class="modal-footer bg-sa-modal-footer">
               <button type="button" class="btn btn-default modal_close color-sa-modal_close" data-bs-dismiss="modal">Close</button>
            </div>
         </div>
         <!--End Modal content-->
      </div>
   </div>
</template>

<script>
import AlertComponent from "../ui/AlertComponent.vue";
import FileUploadProgress from "../ui/FileUploadProgress.vue";

export default {
   name: "ImportModal",
   components: {
      AlertComponent,
      FileUploadProgress,
   },
   props: {
      formImportData: { type: Object, required: true },
      alert: { type: Object, default: null },
      title: { type: String, default: "Import Data" },
      errorsTitle: { type: String, default: "Rows not imported" },
      askSourceSystem: { type: Boolean, default: false },
      sourceSystem: { type: String, default: "" },
      templateUrl: { type: String, default: "" },
      accept: { type: String, default: ".xlsx,.xls,.csv" },
   },
   emits: ["update:sourceSystem", "file-change", "import", "download-template"],
   computed: {
      // Older pages have no importErrors in formImportData
      errors() {
         return this.formImportData.importErrors || [];
      },
      sourceSystemValue: {
         get() { return this.sourceSystem; },
         set(value) { this.$emit("update:sourceSystem", value); },
      },
      canImport() {
         if (!this.formImportData.dataFile) return false;
         if (this.askSourceSystem && !(this.sourceSystem || "").trim()) return false;
         return true;
      },
   },
   watch: {
      // clearImportForm() sets dataFile to null: empty the file box too
      // (the page's $refs can't reach this input any more)
      "formImportData.dataFile"(file) {
         if (!file && this.$refs.fileInput) this.$refs.fileInput.value = null;
      },
   },
};
</script>
